import styled from "styled-components";
import { UserAvatar } from "@wrstudios/components";

export const Avatar = styled(UserAvatar)`
  width: 3.2rem;
  height: 3.2rem;
  font-size: 1.3rem;
`;
